import Box from '~/core/Box'
import Text from '~/core/Text'
import {
    setBoundingBox,
    MM_TO_IN,
    BLACK_ALPHA_BOTTOM,
    HEADER_STYLES,
} from '~/apps/consumer/components/PartViewerModal/logic'
import { BoundingBoxType } from '~/apps/consumer/components/PartViewerModal/types'

export default function BoundingBox(props: BoundingBoxType) {
    const { boundingBox } = props

    return (
        <Box borderBottom={BLACK_ALPHA_BOTTOM} direction="col" padding="16px 0">
            <Text style={HEADER_STYLES}>Dimensions</Text>
            <Box>
                {boundingBox && setBoundingBox(boundingBox)}
                {' mm'}
                <br />
                {boundingBox &&
                    setBoundingBox({
                        width: boundingBox.width / MM_TO_IN,
                        length: boundingBox.length / MM_TO_IN,
                        thickness: boundingBox.thickness / MM_TO_IN,
                        __typename: 'BoundingBox',
                    })}
                {' in'}
            </Box>
        </Box>
    )
}
